<template>
  <div class="input">
    <div class="input-label">半径（m）</div>
    <div class="input-group">
      <input
        type="number"
        min="1"
        class="input-text"
        v-model="radius">
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    radius: {
      get: function () {
        return this.$store.state.quiz.radius
      },

      set: function (value) {
        this.$store.commit(
          'quiz/setRadius',
          value
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';
</style>
